import $ from 'jquery';
import { getIds } from "../app";
var $tagsHolder = document.querySelector('[data-tags]');
var $tagsList = document.querySelector('[data-tags-list]');
if ($tagsList) {
    window.addEventListener('tabChange', function(event) {
        if (event.detail.name === 'params') {
            var allSize = 0;
            var hide = false;
            var hideCount = 0;
            var holderSize = $tagsList.clientWidth;
            var $tags = $tagsList.querySelectorAll('.search-tags__item');
            $tags === null || $tags === void 0 ? void 0 : $tags.forEach(function($item) {
                allSize += $item.clientWidth;
                if (allSize > holderSize) {
                    hide = true;
                    hideCount += 1;
                }
                if (hide) {
                    $item.style.display = 'none';
                }
            });
            if (hide) {
                $tagsHolder.insertAdjacentHTML('beforeend', '<button class="search-tags__more" data-tags-more>Еще '.concat(hideCount, "</button>"));
            }
        }
    });
}
var tid = null;
document.addEventListener('click', function(event) {
    var $el = event.target;
    if ($el.dataset.tagsMore !== undefined) {
        var _$tagsList_querySelectorAll;
        event.preventDefault();
        $tagsHolder.classList.add('search-tags_all');
        $el.remove();
        (_$tagsList_querySelectorAll = $tagsList.querySelectorAll('.search-tags__item')) === null || _$tagsList_querySelectorAll === void 0 ? void 0 : _$tagsList_querySelectorAll.forEach(function($item) {
            $item.removeAttribute('style');
        });
    }
    if ($($el).closest('.rooms-tabs')) {
        clearTimeout(tid);
        tid = setTimeout(function() {
            var ids = getIds();
            $('.fav-icon').each(function() {
                var id = $(this).data('id');
                if (ids.includes(id)) $(this).addClass('fav-active');
            });
        }, 600);
    }
});
